import React from 'react';
import bookingBackground from '../assets/Bookings/1288609237.webp'; // Import your background image

const Bookings = () => {
    const handleBooking = () => {
        // Get all the form values by ID
        const name = document.getElementById('name')?.value || "Not Provided";
        const email = document.getElementById('email')?.value || "Not Provided";
        const contactNumber = document.getElementById('contactNumber')?.value || "Not Provided";
        const dateTime = document.getElementById('dateTime')?.value || "Not Specified";
        const country = document.getElementById('country')?.value || "Not Specified";

        // Get the text of the selected option in the "Tour Name" dropdown
        const tourSelect = document.getElementById('tourName');
        const tourName = tourSelect.options[tourSelect.selectedIndex]?.text || "Not Specified";

        // Get the selected value of the "Persons" dropdown
        const personsSelect = document.getElementById('persons');
        const persons = personsSelect.value || "Not Specified";

        const specialRequest = document.getElementById('specialRequest')?.value || "None";

        // Construct the WhatsApp message
        const whatsappMessage = `**Tour Booking**\n\n` +
            `Name: ${name}\n` +
            `Email: ${email}\n` +
            `Contact Number: ${contactNumber}\n` +
            `Country: ${country}\n` +
            `Date & Time: ${dateTime}\n` +
            `Tour: ${tourName}\n` +
            `Persons: ${persons}\n` +
            `Message: ${specialRequest}`;

        // Encode the WhatsApp message
        const encodedMessage = encodeURIComponent(whatsappMessage);

        // WhatsApp API link
        const whatsappLink = `https://wa.me/94777065854?text=${encodedMessage}`;

        // Open WhatsApp link
        const newWindow = window.open(whatsappLink, '_blank');

        // Handle popup blocking
        if (!newWindow) {
            alert('Popup blocked! Please allow popups for this website to send the WhatsApp message.');
        }
    };




    return (
        <div
            className="min-h-screen flex items-center justify-center bg-blue-700 bg-cover bg-center p-4 sm:p-8 md:p-12 mt-16"
            style={{
                backgroundImage: `url(${bookingBackground})`, // Use the imported background image
            }}
        >
            <div className="bg-white bg-opacity-90 p-4 sm:p-6 md:p-8 rounded-lg shadow-lg w-full max-w-4xl">
                <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-4">
                    Book A Tour Here
                </h2>
                <p className="text-center text-gray-600 mb-6">
                    Embark on Your Dream Adventure with Zelona Tours. Explore Exclusive Deals Just for You!
                </p>
                <form className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    {/* Name Field */}
                    <input
                        id="name"
                        type="text"
                        placeholder="Your Name"
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />

                    {/* Email Field */}
                    <input
                        id="email"
                        type="email"
                        placeholder="Your Email"
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />

                    {/* Contact Number */}
                    <input
                        id="contactNumber"
                        type="tel"
                        placeholder="Contact Number"
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {/* Country Field */}
                    <select
                        id="country"
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="" disabled selected>
                            Select Country
                        </option>
                        <option value="Afghanistan">Afghanistan</option>
                        <option value="Albania">Albania</option>
                        <option value="Algeria">Algeria</option>
                        <option value="Andorra">Andorra</option>
                        <option value="Angola">Angola</option>
                        <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                        <option value="Argentina">Argentina</option>
                        <option value="Armenia">Armenia</option>
                        <option value="Australia">Australia</option>
                        <option value="Austria">Austria</option>
                        <option value="Azerbaijan">Azerbaijan</option>
                        <option value="Bahamas">Bahamas</option>
                        <option value="Bahrain">Bahrain</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Barbados">Barbados</option>
                        <option value="Belarus">Belarus</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Belize">Belize</option>
                        <option value="Benin">Benin</option>
                        <option value="Bhutan">Bhutan</option>
                        <option value="Bolivia">Bolivia</option>
                        <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                        <option value="Botswana">Botswana</option>
                        <option value="Brazil">Brazil</option>
                        <option value="Brunei">Brunei</option>
                        <option value="Bulgaria">Bulgaria</option>
                        <option value="Burkina Faso">Burkina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cabo Verde">Cabo Verde</option>
                        <option value="Cambodia">Cambodia</option>
                        <option value="Cameroon">Cameroon</option>
                        <option value="Canada">Canada</option>
                        <option value="Central African Republic">Central African Republic</option>
                        <option value="Chad">Chad</option>
                        <option value="Chile">Chile</option>
                        <option value="China">China</option>
                        <option value="Colombia">Colombia</option>
                        <option value="Comoros">Comoros</option>
                        <option value="Congo (Congo-Brazzaville)">Congo (Congo-Brazzaville)</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Croatia">Croatia</option>
                        <option value="Cuba">Cuba</option>
                        <option value="Cyprus">Cyprus</option>
                        <option value="Czechia (Czech Republic)">Czechia (Czech Republic)</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Djibouti">Djibouti</option>
                        <option value="Dominica">Dominica</option>
                        <option value="Dominican Republic">Dominican Republic</option>
                        <option value="Ecuador">Ecuador</option>
                        <option value="Egypt">Egypt</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Equatorial Guinea">Equatorial Guinea</option>
                        <option value="Eritrea">Eritrea</option>
                        <option value="Estonia">Estonia</option>
                        <option value="Eswatini (fmr. Swaziland)">Eswatini (fmr. Swaziland)</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Finland">Finland</option>
                        <option value="France">France</option>
                        <option value="Gabon">Gabon</option>
                        <option value="Gambia">Gambia</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Germany">Germany</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Greece">Greece</option>
                        <option value="Grenada">Grenada</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guinea">Guinea</option>
                        <option value="Guinea-Bissau">Guinea-Bissau</option>
                        <option value="Guyana">Guyana</option>
                        <option value="Haiti">Haiti</option>
                        <option value="Holy See">Holy See</option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="India">India</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="Iran">Iran</option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japan">Japan</option>
                        <option value="Jordan">Jordan</option>
                        <option value="Kazakhstan">Kazakhstan</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Kiribati">Kiribati</option>
                        <option value="Korea (North)">Korea (North)</option>
                        <option value="Korea (South)">Korea (South)</option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                        <option value="Laos">Laos</option>
                        <option value="Latvia">Latvia</option>
                        <option value="Lebanon">Lebanon</option>
                        <option value="Lesotho">Lesotho</option>
                        <option value="Liberia">Liberia</option>
                        <option value="Libya">Libya</option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Lithuania">Lithuania</option>
                        <option value="Luxembourg">Luxembourg</option>
                        <option value="Madagascar">Madagascar</option>
                        <option value="Malawi">Malawi</option>
                        <option value="Malaysia">Malaysia</option>
                        <option value="Maldives">Maldives</option>
                        <option value="Mali">Mali</option>
                        <option value="Malta">Malta</option>
                        <option value="Marshall Islands">Marshall Islands</option>
                        <option value="Mauritania">Mauritania</option>
                        <option value="Mauritius">Mauritius</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Micronesia">Micronesia</option>
                        <option value="Moldova">Moldova</option>
                        <option value="Monaco">Monaco</option>
                        <option value="Mongolia">Mongolia</option>
                        <option value="Montenegro">Montenegro</option>
                        <option value="Morocco">Morocco</option>
                        <option value="Mozambique">Mozambique</option>
                        <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                        <option value="Namibia">Namibia</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Nicaragua">Nicaragua</option>
                        <option value="Niger">Niger</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="North Macedonia">North Macedonia</option>
                        <option value="Norway">Norway</option>
                        <option value="Oman">Oman</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Palau">Palau</option>
                        <option value="Palestine State">Palestine State</option>
                        <option value="Panama">Panama</option>
                        <option value="Papua New Guinea">Papua New Guinea</option>
                        <option value="Paraguay">Paraguay</option>
                        <option value="Peru">Peru</option>
                        <option value="Philippines">Philippines</option>
                        <option value="Poland">Poland</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Qatar">Qatar</option>
                        <option value="Romania">Romania</option>
                        <option value="Russia">Russia</option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                        <option value="Saint Lucia">Saint Lucia</option>
                        <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                        <option value="Samoa">Samoa</option>
                        <option value="San Marino">San Marino</option>
                        <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                        <option value="Saudi Arabia">Saudi Arabia</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Serbia">Serbia</option>
                        <option value="Seychelles">Seychelles</option>
                        <option value="Sierra Leone">Sierra Leone</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Slovakia">Slovakia</option>
                        <option value="Slovenia">Slovenia</option>
                        <option value="Solomon Islands">Solomon Islands</option>
                        <option value="Somalia">Somalia</option>
                        <option value="South Africa">South Africa</option>
                        <option value="South Sudan">South Sudan</option>
                        <option value="Spain">Spain</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudan">Sudan</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Syria">Syria</option>
                        <option value="Tajikistan">Tajikistan</option>
                        <option value="Tanzania">Tanzania</option>
                        <option value="Thailand">Thailand</option>
                        <option value="Timor-Leste">Timor-Leste</option>
                        <option value="Togo">Togo</option>
                        <option value="Tonga">Tonga</option>
                        <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                        <option value="Tunisia">Tunisia</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Turkmenistan">Turkmenistan</option>
                        <option value="Tuvalu">Tuvalu</option>
                        <option value="Uganda">Uganda</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Emirates">United Arab Emirates</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States">United States</option>
                        <option value="Uruguay">Uruguay</option>
                        <option value="Uzbekistan">Uzbekistan</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Vatican City">Vatican City</option>
                        <option value="Venezuela">Venezuela</option>
                        <option value="Vietnam">Vietnam</option>
                        <option value="Yemen">Yemen</option>
                        <option value="Zambia">Zambia</option>
                        <option value="Zimbabwe">Zimbabwe</option>
                    </select>

                    {/* Date and Time */}
                    <input
                        id="dateTime"
                        type="datetime-local"
                        placeholder="Date & Time"
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />

                    {/* Tour Name */}
                    <select
                        id="tourName"
                        defaultValue=""
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="" disabled>
                            Tour Name
                        </option>
                        <option value="Tour 1">Ella (One Day)</option>
                        <option value="Tour 2">Galle Fort (One Day)</option>
                        <option value="Tour 3">Yala Safari (One Day)</option>
                        <option value="Tour 4">Kandy (One Day)</option>
                        <option value="Tour 5">Sigiriya (One Day)</option>
                        <option value="Tour 6">Udawalawe (One Day)</option>
                        <option value="Tour 7">Colombo City (One Day)</option>
                        <option value="Tour 8">Mirissa Whale Watching (One Day)</option>
                        <option value="Tour 9">Bentota River Safari (One Day)</option>
                        <option value="Tour 10">Ella & Yala (One Day)</option>
                        <option value="Tour 11">Ella & Galle (One Day)</option>
                        <option value="Tour 12">Yala & Galle (One Day)</option>
                        <option value="Tour 13">Ella & Yala (Two Days)</option>
                        <option value="Tour 14">Ella/Nuwara Eliya/Kandy (Two Days)</option>
                        <option value="Tour 15">Kandy & Sigiriya (Two Days)</option>
                        <option value="Tour 16">Ella & Nuwara Eliya (Two Days)</option>
                        <option value="Tour 17">Sigiri/Kandy/Ella (Three Days)</option>
                        <option value="Tour 18">Kandy/Nuwara Eliya/Ella/Yala (Three Days)</option>
                        <option value="Tour 19">Sigiriya/Anuradhapura/Polonnaruwa/ Minneriya National Park Safari (Three Days)</option>
                        <option value="Tour 20">Kandy/Nuwara Eliya/Horton Plains (Three Days)</option>
                    </select>


                    {/* Persons */}
                    <select
                        id="persons"
                        className="border rounded-md p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="" disabled selected>
                            Persons
                        </option>
                        <option value="1">1 Person</option>
                        <option value="2">2 Persons</option>
                        <option value="3">3 Persons</option>
                        <option value="4">4 Persons</option>
                        <option value="5">5 Persons</option>
                        <option value="6">6 Persons</option>
                    </select>

                    {/* Special Request */}
                    <textarea
                        id="specialRequest"
                        placeholder="Special Request"
                        className="border rounded-md p-3 w-full md:col-span-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        rows="4"
                    ></textarea>
                </form>
                <div className="mt-6 text-center">
                    <button
                        type="button"
                        onClick={handleBooking}
                        className="w-full bg-blue-600 text-white text-lg font-medium px-6 py-3 rounded-md hover:bg-blue-700 transition duration-300"
                    >
                        Book Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Bookings;
